import script from "./LoginButtonContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginButtonContainer.vue?vue&type=script&setup=true&lang=js"

import "./LoginButtonContainer.vue?vue&type=style&index=0&id=346f324f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346f324f"]])

export default __exports__